module.exports = __webpack_public_path__ + "img/8.0d894418.png";